export default "__VITE_ASSET__BAD6CVXG__"